import React, { useState } from "react";
import ConfirmWithPhrasePopup from "../Common/ConfirmWithPhrasePopup";
import { participantsAPI } from "../../api/apiClient";
import "../../css/Popups/BulkCorrectionPopup.css";
import getParticipantStatusStyle from "../../utils/getParticipantStatusStyle";
import useApi from "../CustomHooks/useApi";
import { useToast } from "../../Contexts/ToastContext";
import { useTripContext } from "./TripContext";

const BulkCorrectionPopup = ({ onClose, participants, variantGuid }) => {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [selected, setSelected] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const { callApi, isLoading } = useApi();
  const { showToast, clearToast } = useToast();
  const { fetchTripData } = useTripContext();
  const [statusFilter, setStatusFilter] = useState("all");
  const toggleParticipant = (guid) => {
    setSelected((prev) =>
      prev.includes(guid) ? prev.filter((g) => g !== guid) : [...prev, guid]
    );
  };

  const toggleAll = () => {
    if (selected.length === participants.length) setSelected([]);
    else setSelected(participants.map((p) => p.guid));
  };

  const handleSubmit = async () => {
    setShowConfirm(false);
    showToast("Dodawanie zbiorczej korekty", "processing");
      await callApi(
        async () =>
        participantsAPI.addBulkCorrections({
          participantGuids: selected,
          amount: parseFloat(amount),
          note,
          variantGuid,
        }),
        async () => {
        await fetchTripData();
        showToast(`Dodano korekty dla ${selected.length} uczestników`, "success");
        onClose();
      }, 
        clearToast
      );
    }

  const sortedParticipants = [...participants].sort((a, b) =>
    a.preferredName.localeCompare(b.preferredName, "pl")
  );

  return (
    <div className="bulkcorrection-popup-overlay">
      <div className="bulkcorrection-popup-content">
        <h2>Korekta zbiorcza opłat</h2>
        <input
          type="number"
          placeholder="Kwota"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <input
          type="text"
          placeholder="Opis korekty"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        <div className="bulkcorrection-bulk-controls">
          <div onClick={toggleAll}>
            {selected.length === participants.length ? "Odznacz wszystkich" : "Zaznacz wszystkich"}
          </div>
        </div>
        <div className="bulkcorrection-participants-header">
          Zaznaczono: {selected.length} / {participants.length}
        </div>
        
        <div className="bulkcorrection-participants-list">
          {sortedParticipants.map((p) => {
            const isSelected = selected.includes(p.guid);
            const { icon, statusClass } = getParticipantStatusStyle(p.status);
            return (
              <div
                key={p.guid}
                className={`bulkcorrection-participant-item ${isSelected ? "selected" : ""}`}
                onClick={() => toggleParticipant(p.guid)}
              >
                <i className={`fa-solid ${icon} ${statusClass}`} />
                <span className={statusClass}>{p.preferredName}</span>
              </div>
            );
          })}
        </div>
          <div className="bulkcorrection-popup-actions">
          <div
            className={`bulkcorrection-cancel ${isLoading ? "disabled" : ""}`}
            style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
            onClick={() => {
              if (!isLoading) onClose();
            }}
          >
  Anuluj
</div>

    <div
      className={`bulkcorrection-confirm ${
        !amount || !note.trim() || selected.length === 0 || isLoading ? "disabled" : ""
      }`}
      style={{ cursor: !amount || !note.trim() || selected.length === 0 || isLoading ? "not-allowed" : "pointer" }}
      onClick={() => {
        if (!isLoading && amount && note.trim() && selected.length > 0) {
          setShowConfirm(true);
        }
      }}
    >
      {isLoading ? (
        <>
          <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: 6 }} />
          Zapisywanie...
        </>
      ) : (
        "Zapisz"
      )}
    </div>
          </div>


        {showConfirm && (
          <ConfirmWithPhrasePopup
          phrase="okoń"
            text={`Czy na pewno chcesz dodać korektę ${amount} zł dla ${selected.length} uczestników?`}
            onConfirm={handleSubmit}
            onCancel={() => setShowConfirm(false)}
          />
        )}
      </div>
    </div>
  );
};

export default BulkCorrectionPopup;
